<template>
  <div class="orders-history-list">
    <ul class="orders-history-list__list">
      <component
        v-for="order in orders"
        :key="order.id"
        :is="getComponentForOrder(order)"
        :order="order"
      />
    </ul>
    <p class="orders-history-list__notes">* вказана ціна продажу страхового полісу</p>
  </div>
</template>

<script>
import ExternalListItem from './external-list-item';
import GreenCardListItem from './green-card-list-item';
import HomeListItem from './home-list-item';
import OsagoListItem from './osago-list-item';
import PetsListItem from './pets-list-item';
import TourismListItem from './tourism-list-item';
import { ORDER_TYPE } from '@/shared/config/order-type';

export default {
  props: {
    orders: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  components: { OsagoListItem, GreenCardListItem, TourismListItem, HomeListItem, ExternalListItem, PetsListItem },
  methods: {
    getComponentForOrder(order) {
      switch (order.typeId) {
        case ORDER_TYPE.OSAGO:
        case ORDER_TYPE.BUS:
        case ORDER_TYPE.DGO:
        case ORDER_TYPE.AUTOLAWYER:
          return 'OsagoListItem';
        case ORDER_TYPE.GREEN_CARD:
          return 'GreenCardListItem';
        case ORDER_TYPE.TOURISM:
          return 'TourismListItem';
        case ORDER_TYPE.HOME:
          return 'HomeListItem';
        case ORDER_TYPE.EXTERNAL:
          return 'ExternalListItem';
        case ORDER_TYPE.PETS:
          return 'PetsListItem';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.orders-history-list {
  &__notes {
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    color: #71717A;

    @media (max-width: 550px) {
      text-align: left;
    }
  }
}
</style>
